import React, { useState } from "react";
import { viewDocument, downloadDocument, normalizeDocRef, openDocumentPreviewTab } from "../mobile/documentActions";
import { isNativeApp } from "../core/platform";
import { useApp } from "../core/context";
import { InlineIcon } from "./Icon";

/** View + Download buttons for stored docs (web + mobile WebView). */
export function DocActions({
  doc,
  name,
  onError,
  compact = false,
  storagePath,
  listPrefix,
  companyId,
  taskId,
  dirIdx,
  slotId,
  files,
}) {
  const [busy, setBusy] = useState(null);
  const { openModal } = useApp() || {};
  const ref = normalizeDocRef(doc, name);
  if (!ref) return null;
  // Mobile app: doc view/download hidden until in-app viewer is App Store–ready; web unchanged.
  if (isNativeApp()) return null;

  const viewCtx = { storagePath, listPrefix, companyId, taskId, dirIdx, slotId, files };

  const run = async (action) => {
    if (busy) return;
    setBusy(action);
    try {
      if (action === "view" && isNativeApp() && openModal) {
        openModal("view-document", { doc: ref, name, ...viewCtx });
      } else if (action === "view") {
        const docName = ref.name || name || "document";
        const tab = openDocumentPreviewTab(docName);
        await viewDocument(ref, name, viewCtx, tab);
      } else {
        await downloadDocument(ref, name, viewCtx);
      }
    } catch (e) {
      onError?.(e.message || "Document action failed");
    }
    setBusy(null);
  };

  return (
    <div style={{ display: "flex", gap: compact ? 4 : 6, flexShrink: 0 }}>
      <button type="button" className="btn btn-sm" disabled={!!busy} onClick={() => run("view")}>
        <InlineIcon name="view" size={12} gap={compact ? 3 : 4}>{busy === "view" ? "…" : "View"}</InlineIcon>
      </button>
      <button type="button" className="btn btn-sm btn-primary" disabled={!!busy} onClick={() => run("download")}>
        <InlineIcon name="download" size={12} gap={compact ? 3 : 4}>{busy === "download" ? "…" : "Download"}</InlineIcon>
      </button>
    </div>
  );
}
